import { apiService } from './apiService';

export const payrollService = {
  async getPayrolls(params?: { year?: number; month?: number }) {
    const queryParams = new URLSearchParams();
    if (params?.year) queryParams.append('year', String(params.year));
    if (params?.month) queryParams.append('month', String(params.month));

    const query = queryParams.toString();
    return await apiService.get(`/payrolls${query ? `?${query}` : ''}`);
  },

  async getMyPayrolls(params?: { year?: number; month?: number }) {
    const queryParams = new URLSearchParams();
    if (params?.year) queryParams.append('year', String(params.year));
    if (params?.month) queryParams.append('month', String(params.month));

    const query = queryParams.toString();
    return await apiService.get(`/payrolls/my${query ? `?${query}` : ''}`);
  },

  async uploadPayroll(formData: FormData) {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    const token = localStorage.getItem('authToken');

    const response = await fetch(`${baseUrl}/payrolls/upload`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: formData,
    });

    const rawBody = await response.text();
    let data: any = {};
    if (rawBody) {
      try {
        data = JSON.parse(rawBody);
      } catch {
        if (!response.ok) {
          const compactBody = rawBody.replace(/\s+/g, ' ').slice(0, 300);
          throw new Error(`Bordro yüklenemedi: sunucu beklenmeyen bir yanıt döndürdü (${compactBody})`);
        }
      }
    }

    if (!response.ok) {
      throw new Error(data.message || 'Bordro yüklenemedi');
    }

    return data;
  },

  async deletePayroll(id: string | number) {
    return await apiService.delete(`/payrolls/${id}`);
  },
};
